import React, { useState } from "react";

export default function Modal({ open, onClose, title, subtitle, children, size = "md" }) {
  if (!open) return null;
  const widths = { sm: "max-w-md", md: "max-w-xl", lg: "max-w-3xl" };
  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4 bg-obsidian-950/70 backdrop-blur-sm" onClick={onClose}>
      <div
        className={`card w-full ${widths[size]} overflow-hidden`}
        onClick={(e) => e.stopPropagation()}
        data-testid="modal"
      >
        <div className="flex items-start justify-between p-5 border-b border-line">
          <div>
            <div className="font-heading text-lg font-bold tracking-tight">{title}</div>
            {subtitle && <div className="text-xs text-obsidian-400 mt-0.5">{subtitle}</div>}
          </div>
          <button onClick={onClose} className="btn-ghost h-8 w-8 p-0" data-testid="modal-close">×</button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}

export function ConfirmDialog({ open, onClose, onConfirm, title, message, confirmLabel = "Confirmer" }) {
  return (
    <Modal open={open} onClose={onClose} title={title} size="sm">
      <p className="text-sm text-obsidian-300 mb-6">{message}</p>
      <div className="flex justify-end gap-2">
        <button onClick={onClose} className="btn-secondary" data-testid="confirm-cancel">Annuler</button>
        <button onClick={() => { onConfirm(); onClose(); }} className="btn-danger" data-testid="confirm-ok">{confirmLabel}</button>
      </div>
    </Modal>
  );
}
